import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=35c271dd&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=35c271dd&prod&lang=css"
import style1 from "./Privacy.vue?vue&type=style&index=1&id=35c271dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c271dd",
  null
  
)

export default component.exports